import {useState, useEffect} from 'react';
import type {ReactNode} from 'react';

type TProps = {
	title: string;
	children: ReactNode;
	onShow?: () => void;
};

const CardBasic = ({title = '', children, onShow}: TProps) => {
	const [titleCard, setTitleCard] = useState('');

	useEffect(() => {
		setTitleCard(title ? title : '');
	}, [title]);

	return (
		<div className="card shadow mb-4">
			<div className="card-header py-3 text-center">
				<h6 className="m-0 font-weight-bold text-primary">{titleCard}</h6>
			</div>
			{onShow && (
				<button className="border-0 bg-transparent d-inline" onClick={onShow}>
					<i
						className="bi-1 bi-eye"
						title=""
						data-toggle="tooltip"
						data-original-title="XML View"
					/>{' '}
					Show all
				</button>
			)}

			<div className="card-body">{children}</div>
		</div>
	);
};

export default CardBasic;
